import { formatDate } from '@angular/common';
import { Component, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-resource-planning',
  templateUrl: './resource-planning.component.html',
  styleUrls: ['./resource-planning.component.css']
})
export class ResourcePlanningComponent implements OnInit {

  // campaignOne: FormGroup;
  startDate: string;
  endDate: string;
  empCode: string;
  empName: string;
  projectName: string;
  projectCode: string;
  // searchFlag: Boolean = false;

  constructor() { 
   
  }

  ngOnInit(): void {
    let today = new Date();
    let minusThreeMonths = new Date(today.setMonth(today.getMonth() - 3));
    this.startDate = minusThreeMonths.toISOString().substring(0, 10); 
    today = new Date();
    let nextThreeMonths = new Date(today.setMonth(today.getMonth() + 3));
    this.endDate = nextThreeMonths.toISOString().substring(0, 10); 
  }

  
  onSearchClick() {
    // this.searchFlag = true;
    
    if(this.endDate)
      if(this.endDate < this.startDate){
          this.endDate = this.startDate;
        }

    setTimeout(() => {
      // this.searchFlag = false;
    }, 10000);
  
  }

  clearSearchSection(){
     let today = new Date();
     let minusThreeMonths = new Date(today.setMonth(today.getMonth() - 3));
     today = new Date();
     let nextThreeMonths = new Date(today.setMonth(today.getMonth() + 3));
     this.startDate = minusThreeMonths.toISOString().substring(0, 10); 
     this.endDate = nextThreeMonths.toISOString().substring(0, 10); 
     this.empCode = null;
     this.empName = null;
     this.projectName = null;
     this.projectCode = null;
  }


}
